import React from "react";
import { bool, number, oneOfType, string } from "prop-types";

import { handleSetPassword } from "../../../utilities";
import { ACCOUNT_TITLE } from "../constants";
import {
  ItemText,
  ListTitle,
  MenuList,
  MultiLevelMenu
} from "../MultiLevelMenu";

const Account = ({
  is_agent_or_small_landlord,
  is_free_pass,
  is_notification_preferences,
  masquerader,
  masquerader_login
}) => (
  <MultiLevelMenu title={ACCOUNT_TITLE}>
    {is_free_pass ? (
      <MenuList isSubMenu>
        <li>
          <ItemText href="#" onClick={handleSetPassword}>
            Set a Password
          </ItemText>
        </li>
      </MenuList>
    ) : null}
    <ListTitle>{ACCOUNT_TITLE}</ListTitle>
    <MenuList isSubMenu>
      {masquerader ? (
        <li>
          <ItemText href="/nyc/admin/users/stop_masquerade">
            Become {masquerader_login} again
          </ItemText>
        </li>
      ) : null}
      {!is_agent_or_small_landlord ? (
        <li>
          <ItemText href="/my/account_profile">Profile</ItemText>
        </li>
      ) : null}
      {is_notification_preferences ? (
        <li>
          <ItemText href="/nyc/user/notification_preferences">
            Notifications
          </ItemText>
        </li>
      ) : (
        <li>
          <ItemText href="/nyc/user/email_preferences">
            Email Preferences
          </ItemText>
        </li>
      )}
      <li>
        <ItemText href="/my">Settings</ItemText>
      </li>
      <li>
        <ItemText href="/nyc/user/logout">Sign Out</ItemText>
      </li>
    </MenuList>
  </MultiLevelMenu>
);

Account.propTypes = {
  is_free_pass: bool,
  is_agent_or_small_landlord: bool,
  is_notification_preferences: bool,
  masquerader_login: string,
  masquerader: oneOfType([number, string])
};

Account.defaultProps = {
  is_free_pass: false,
  is_agent_or_small_landlord: false,
  is_notification_preferences: false,
  masquerader_login: undefined,
  masquerader: null
};

export default Account;
